import { c as _c } from "react/compiler-runtime";
import { Button, Dialog, Tooltip } from "@flat-ui";
import { assert } from "@faro-lotv/foundation";
import { useUserContext } from "@pages/account-settings/user-provider";
import { runtimeConfig } from "@src/runtime-config";
import { DEFAULT_BOLD_TEXT_FONT_WEIGHT, DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { getMailHref } from "@utils/email-utils";
import { UserProfile } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getPrettyName } from "@utils/user-utils";
import { useState } from "react";

/** Let user to request deleting their account */
export function AccountDeletion() {
  const $ = _c(11);
  const {
    user
  } = useUserContext();
  assert(user, "User has to be defined to delete account");
  const [isAccountDeletionDialogOpen, setIsAccountDeletionDialogOpen] = useState(false);
  const {
    trackEvent
  } = useTrackEvent();
  let t0;
  if ($[0] !== user) {
    t0 = getPrettyName(user);
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const body = encodeURIComponent(`I would like to request the deletion of my account associated with the email ${user.email}.\n` + "Please proceed with permanently removing my account and all related data as per your policies.\n" + "I understand that this action is irreversible and may take some time to complete.\n" + "Kindly confirm once the deletion process has been initiated or if any additional steps are required from my end.\n" + `Thank you for your assistance.\n\nBest regards,\n${t0}`);
  let t1;
  if ($[2] !== body || $[3] !== trackEvent) {
    t1 = function onDeleteAccountConfirm() {
      trackEvent({
        name: UserProfile.deleteAccount
      });
      window.open(getMailHref({
        additionalEmails: [runtimeConfig.mailSupportAddress],
        subject: "Request deleting my account",
        body
      }));
      setIsAccountDeletionDialogOpen(false);
    };
    $[2] = body;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onDeleteAccountConfirm = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsAccountDeletionDialogOpen(true);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Tooltip component="div" title="Delete account permanently"><Button variant="destructiveGhost" onClick={t2} disableFocusRipple={true} disableRipple={true} disableElevation={true} disableTouchRipple={true} draggable={false} sx={{
        fontSize: DEFAULT_INPUT_FONT_SIZE,
        fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT,
        textTransform: "none",
        width: "100%"
      }}>Delete account</Button></Tooltip>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsAccountDeletionDialogOpen(false);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isAccountDeletionDialogOpen || $[9] !== onDeleteAccountConfirm) {
    t5 = <>{t3}<Dialog title="Request account deletion" open={isAccountDeletionDialogOpen} onCancel={t4} onConfirm={onDeleteAccountConfirm} variant="danger" confirmText="Request deletion">Deleting your account is a permanent action. By confirming this request, our support team will initiate the deletion process.</Dialog></>;
    $[8] = isAccountDeletionDialogOpen;
    $[9] = onDeleteAccountConfirm;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}